// extracted by mini-css-extract-plugin
export default {"wrapper":"UYDGpbSu","mobileMenu":"v06r4uWz","menuContainer":"nMnXZC7Z","menu":"wUEXQarp"};